const initialState = {
  isTradeExecuted: false,
  lastClosedTrade: null,
};

export const TradeReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'TRADE_ADDED':
      return { ...state, isTradeExecuted: true };
    case 'TRADE_CANCLE':
      return { ...state, isTradeExecuted: true };
    case 'TRADE_CLOSED':
      return {
        ...state,
        isTradeExecuted: true,
        lastClosedTrade: action.payload || null,
      };
    case 'RESET_TRADE':
      return { ...state, isTradeExecuted: false };
    default:
      return state;
  }
};
